import { Reveal } from "./Reveal";
import { WhatsAppButton, CallButton } from "./WhatsAppButton";
import { PHONE_DISPLAY } from "../data/siteData";

export const CTASection = ({
  eyebrow = "Begin Your Session",
  title = "Reserve your moment of calm",
  copy = "Message us on WhatsApp and our concierge will arrange your service — private suite, warm oils, unhurried hands.",
}) => (
  <section className="relative overflow-hidden py-28" data-testid="cta-section">
    <div className="ambient-glow pointer-events-none absolute inset-0" />
    <div className="relative mx-auto max-w-4xl px-6 text-center">
      <Reveal>
        <p className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-amber-400/80">{eyebrow}</p>
        <h2 className="mt-6 font-display text-4xl font-light leading-[1.08] tracking-tight text-amber-50 sm:text-5xl lg:text-6xl">
          {title.split("calm").length > 1 ? (
            <>
              {title.split("calm")[0]}
              <em className="text-gold-gradient not-italic">calm</em>
              {title.split("calm")[1]}
            </>
          ) : (
            title
          )}
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-stone-400">{copy}</p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <WhatsAppButton testid="cta-whatsapp-booking-btn" />
          <CallButton label={PHONE_DISPLAY} testid="cta-call-btn" />
        </div>
      </Reveal>
    </div>
  </section>
);
